import { useNavigate } from "react-router-dom";
import GridView from "../../components/controls/GridView/GridView";
import withdrawalService, {
  Withdrawal,
} from "../../services/withdrawalService";
import "./withdrawalListingPage.css";
import { useState } from "react";
import { MenuItem } from "../../models/menu";
import Frame from "../../components/controls/Frame/Frame";
import FindAccount from "../../components/controls/FindAccount/FindAccount";
import FormCommand from "../../components/controls/FormCommand";
import FormModal from "../../components/controls/FormModal";
import ContextMenu from "../../components/controls/ContextMenu/ContextMenu";

export interface WithdrawalListingPageProps {
  displayHeader?: boolean;
}

export function getWithdrawalContextMenu(): MenuItem<Withdrawal>[] {
  return [
    {
      name: "Edit",
      onClick: (d) => {
        alert(d.accountNo);
      },
    },
    {
      name: "Delete",
      onClick: (d) => {
        alert(d.accountNo);
      },
    },
    {
      name: "Post Withdrawal",
      onClick: (d) => {
        // TODO: Check if already posted. If already posted. then do not post the transaction again!
        alert("post wd" + d.accountNo + "-" + d.accountName);
      },
    },
    {
      name: "Reverse WD",
      onClick: (d) => {
        // TODO : Check if already posted or reversed. If already posted then do not post the transaction again!
        alert("Reverse WD");
      },
    },
  ];
}

export const WithdrawalListingPage = (props: WithdrawalListingPageProps) => {
  const navigate = useNavigate();
  const [withdrawals, setWithdrawals] = useState<Withdrawal[]>([]);
  const [withdrawal, setWithdrawal] = useState<Withdrawal>();

  const getWithdrawals = async () => {
    const resp = await withdrawalService.getWithdrawals({
      narration: "",
    });

    if (resp?.status) {
      setWithdrawals(resp.data ?? []);
    }
  };

  getWithdrawals();

  return (
    <>
      <div className="row">
        <div className="col">
          <Frame>
            <h4>
              Withdrawals <small className="text-secondary">Transaction</small>
            </h4>
            <p className="text-secondary">
              Displays the list of withdrawal transactions
            </p>
            <GridView
              showAddButton={true}
              rowsPerPage={50}
              showSearchBar={true}
              context="Withdrawals"
              onAddRecord={() => setWithdrawal({})}
            >
              <GridView.Header>
                <thead>
                  <tr>
                    <th>Account Name</th>
                    <th>Narration</th>
                    <th>Amount</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
              </GridView.Header>
              <GridView.Content>
                {withdrawals.map((d) => (
                  <tr>
                    <td>{d.accountName}</td>
                    <td>{d.narration}</td>
                    <td>{d.amount}</td>
                    <td>
                      <span className="badge bg-secondary">
                        {d.transactionStatus == 1 ? "Posted" : "Pending"}
                      </span>
                    </td>
                    <td>
                      <ContextMenu item={d} menu={getWithdrawalContextMenu()} />
                    </td>
                  </tr>
                ))}
              </GridView.Content>
            </GridView>
          </Frame>
        </div>
      </div>

      {withdrawal && (
        <FormModal onClose={() => setWithdrawal(undefined)}>
          <WithdrawalForm />
        </FormModal>
      )}
    </>
  );
};

export function WithdrawalForm() {
  return (
    <div className="row">
      <div className="col">
        <FindAccount id="accountId" text="Account" />

        <div className="form-group">
          <label htmlFor="narration" className="control-label">
            Narration / Description
          </label>
          <textarea
            name="narration"
            id="narration"
            className="form-control form-control-sm"
          ></textarea>
        </div>

        <div className="row">
          <div className="col">
            <div className="form-group">
              <label htmlFor="amount" className="control-label">
                Amount
              </label>
              <input
                type="number"
                name="amount"
                id="amount"
                min={0}
                className="form-control form-control-sm"
              />
            </div>
          </div>
          <div className="col">
            <div className="form-group">
              <label htmlFor="slipNo" className="control-label">
                SlipNo
              </label>
              <input
                type="number"
                name="slipNo"
                id="slipNo"
                min={0}
                className="form-control form-control-sm"
              />
            </div>
          </div>
        </div>

        <FormCommand />
      </div>
    </div>
  );
}
